import type { ReactNode, SVGProps } from "react";

export function ArrowDownIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="5"
			viewBox="0 0 8 5"
			width="8"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4.00149 3.49273L7.02642 0.183554C7.25032 -0.0611846 7.61236 -0.0611846 7.83387 0.183554C8.05538 0.428292 8.05538 0.824039 7.83387 1.06878L4.4064 4.81796C4.18965 5.05489 3.84191 5.0601 3.61801 4.83619L0.166728 1.07138C0.0547821 0.949012 0 0.787589 0 0.628769C0 0.46995 0.0547821 0.308527 0.166728 0.186158C0.390621 -0.0585808 0.752661 -0.0585808 0.974172 0.186158L4.00149 3.49273Z"
				fill="currentColor"
			/>
		</svg>
	);
}
